module.exports = __webpack_public_path__ + "static/media/Cowbell-1.4121f204.wav";